import React from 'react';
import { AIIslandDiff } from './AIIslandDiff';

export function AIIslandResponse({
  response,
  isStreaming,
  emptyLabel,
  responseLabel,
  diffLabels,
  streamingLabel,
  onAcceptAll,
  onAcceptChunk,
}) {
  if (isStreaming) {
    return (
      <div className="ai-island-response">
        {responseLabel && <div className="ai-island-response__label">{responseLabel}</div>}
        <div className="ai-island-response__streaming">
          <span className="ai-island-response__dot" />
          <span className="ai-island-response__dot" />
          <span className="ai-island-response__dot" />
          <span>{streamingLabel || 'Generating response…'}</span>
        </div>
      </div>
    );
  }

  if (!response) {
    return (
      <div className="ai-island-response">
        {responseLabel && <div className="ai-island-response__label">{responseLabel}</div>}
        <div className="ai-island-response__placeholder">{emptyLabel}</div>
      </div>
    );
  }

  if (response.type === 'rewrite' && response.diff) {
    return (
      <div className="ai-island-response">
        {responseLabel && <div className="ai-island-response__label">{responseLabel}</div>}
        <AIIslandDiff
          original={response.diff.original}
          revised={response.diff.revised}
          onAcceptAll={onAcceptAll}
          onAcceptChunk={onAcceptChunk}
          titleLabel={diffLabels?.title}
          acceptAllLabel={diffLabels?.acceptAll}
        />
      </div>
    );
  }

  return (
    <div className="ai-island-response">
      {responseLabel && <div className="ai-island-response__label">{responseLabel}</div>}
      <div className="ai-island-response__content">{response.content}</div>
    </div>
  );
}
